/**
 * Resize tools for the front-end.
 *
 * IMPORTANT: There is a separate version of this for the editor.
 */
(() => {
    let debounceTimeout;
    let debounceDelay = 100;

    /**
     * A debounce function to be called every time the viewport is resized. After no calls have been
     * made for `debounceDelay` milliseconds, the function sends a custom `resize-debounce`
     * event to the window.
     */
    function resizeDebounce() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            window.dispatchEvent(new Event('resize-debounce'));
        }, debounceDelay);
    }

    window.addEventListener('resize', resizeDebounce);
})();
